import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GlobalApp} from "../../../tools/global";
import {InteractivesService} from "../../../api/services/interactives.service";
// @ts-ignore
import pbi from "powerbi-client";
import {PartnerEmbedDetails} from "../../../api/models/partner-embed-details";
import {PartnerEmbedPreFilter} from "../../../api/models/partner-embed-pre-filter";
import {PowerBIService} from "../../../api/services/power-bi.service";
import { PreFilterService } from "../../../api/services";
import { US_PreFilter } from "../../../api/models";

@Component({
  selector: 'app-partner-embed',
  templateUrl: './partner-embed.component.html'
})
export class PartnerEmbedComponent implements OnInit {
  @ViewChild("pbiContainer") pbiContainer: ElementRef;
  private partnerApiKey: string = '';

  private firstLoad: boolean = true;

  private powerBiClientService: pbi.service.Service;
  private embeddedReport: pbi.Report = null;
  private currentConfig: pbi.IEmbedConfiguration = null;

  private partnerEmbed: PartnerEmbedDetails;
  private lastPage: any = undefined;

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private powerbiService: PowerBIService,
    private interactiveService: InteractivesService,
    private preFilterService: PreFilterService
  ) {
    this.powerBiClientService = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );

    this.app.setFullScreenMode();
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.partnerApiKey = params.get("partnerApiKey");
      this.loadReportDetails();
    });
  }

  loadReportDetails() {
    this.interactiveService.interactivesGetPartnerEmbedDetails(this.partnerApiKey).subscribe(result => {
      this.partnerEmbed = result;

      this.powerbiService.powerBIGetPowerBISettingsForInteractive(this.partnerEmbed.interactId).subscribe(settingsResult => {

        this.preFilterService.preFilterGetPartnerEmbedPreFilterByApiKey(this.partnerApiKey).subscribe(preFilter => {
          this.currentConfig = {
            type: "report",
            id: settingsResult.reportId,
            embedUrl: settingsResult.embedUrl,
            accessToken: settingsResult.accessToken,
            filters: /*preFilter ? this.generatePreFilterValues(result, preFilter, regions, industries, occupations) :*/ undefined,
            settings: {
              navContentPaneEnabled: false,
              bookmarksPaneEnabled: false,
              filterPaneEnabled: false,
              bars: {
                actionBar: {
                  visible: false,
                },
              },
            },
          };

          this.embeddedReport = this.powerBiClientService.embed(
            this.pbiContainer.nativeElement,
            this.currentConfig
          ) as pbi.Report;

          this.app.pushLoading("Loading...");

          this.embeddedReport.on("rendered", (_) => {
            if (this.firstLoad) {
              if (this.partnerEmbed.startPage && this.partnerEmbed.startPage !== '') {
                window.setTimeout(() => {
                  this.embeddedReport.setPage(this.partnerEmbed.startPage);
                }, 1000);
              }
              this.firstLoad = false;
              this.app.popLoading();
            }
          });

          this.embeddedReport.on(
            "pageChanged",
            (parameters: CustomEvent) => {
              const newPage = parameters.detail.newPage;

              if (this.partnerEmbed.pageRestrictions) {
                let isAllowed: boolean = false;
                this.partnerEmbed.pageRestrictions.forEach(page => {
                  if (page.page === newPage.name) {
                    isAllowed = true;
                  }
                });

                if (!isAllowed && this.lastPage) {
                  this.embeddedReport.setPage(this.lastPage.name);
                } else {
                  this.lastPage = newPage;
                }
              }
            });
        });
      });
    });
  }

  /*generatePreFilterValues(currentInteractive: PartnerEmbedDetails, preFilter: US_PreFilter, regions: PfkRegionState[], industries: PfkLinkedinIndustry[], occupations: PfkOccupationMajorGroup[]): any[] {
    var resultFilters = [];

    var titles: string[] = [];
    var fuzzyTitles: string[] = [];
    var companies: string[] = [];
    var fuzzyCompanies: string[] = [];
    var stateIds: string[] = [];
    var stateCbsas: string[] = [];
    var industrySectorIds: string[] = [];
    var industryIndustryIds: string[] = [];
    var occupationMajorGroupIds: string[] = [];
    var occupationMinorGroupIds: string[] = [];
    var occupationBroadGroupIds: string[] = [];
    var occupationDetailIds: string[] = [];
    var occupationSocCodes: string[] = [];

    preFilter.preFilterValues.forEach(preFilterValue => {
      switch (preFilterValue.valueType) {
        case 0: titles.push(preFilterValue.value); break;                     // Title
        case 1: companies.push(preFilterValue.value); break;                  // Company
        case 2: stateIds.push(preFilterValue.value); break;                   // Region - State
        case 3: stateCbsas.push(preFilterValue.value); break;                 // Region - CBSA
        case 4: industrySectorIds.push(preFilterValue.value); break;          // Industry - Sector
        case 5: industryIndustryIds.push(preFilterValue.value); break;         // Industry - Sub Sector
        case 6: occupationMajorGroupIds.push(preFilterValue.value); break;    // Occupation - Major Group
        case 7: occupationMinorGroupIds.push(preFilterValue.value); break;    // Occupation - Minor Group
        case 8: occupationBroadGroupIds.push(preFilterValue.value); break;   // Occupation - Broad Group
        case 9: occupationDetailIds.push(preFilterValue.value); break;         // Occupation - Details
        case 10: occupationSocCodes.push(preFilterValue.value); break;        // Occupation - ONET Soc Code
        case 11: fuzzyTitles.push(preFilterValue.value); break;               // Title Fuzzy Search
        case 12: fuzzyCompanies.push(preFilterValue.value); break;            // Company Fuzzy Search
      }
    });

    //Grab all the lowest level items ONLY

    occupations.forEach(majorGroup => {
      if (occupationMajorGroupIds.find(x => x === majorGroup.majorGroupId)) {
        majorGroup.minorGroups.forEach(minorGroup => {
          minorGroup.broadGroups.forEach(broadGroup => {
            broadGroup.occupationDetails.forEach(details => {
              details.occupationOnets.forEach(onet => {
                occupationSocCodes.push(onet.onetSocCode);
              });
            });
          });
        });
      } else {
        majorGroup.minorGroups.forEach(minorGroup => {
          if (occupationMinorGroupIds.find(x => x === minorGroup.minorGroupId)) {
            minorGroup.broadGroups.forEach(broadGroup => {
              broadGroup.occupationDetails.forEach(details => {
                details.occupationOnets.forEach(onet => {
                  occupationSocCodes.push(onet.onetSocCode);
                });
              });
            });
          } else {
            minorGroup.broadGroups.forEach(broadGroup => {
              if (occupationBroadGroupIds.find(x => x === broadGroup.broadGroupId)) {
                broadGroup.occupationDetails.forEach(details => {
                  details.occupationOnets.forEach(onet => {
                    occupationSocCodes.push(onet.onetSocCode);
                  });
                });
              } else {
                broadGroup.occupationDetails.forEach(details => {
                  if (occupationDetailIds.find(x => x === details.detailId)) {
                    details.occupationOnets.forEach(onet => {
                      occupationSocCodes.push(onet.onetSocCode);
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    industries.forEach(sector => {
      if (industrySectorIds.find(x => x === sector.subIndustries.toString())) {
        sector.subIndustries.forEach(industry => {
          industryIndustryIds.push(industry.subIndustry.toString());
        });
      }
    });

    regions.forEach(state => {
      if (stateIds.find(x => x === state.state)) {
        state.metroAreas.forEach(metroArea => {
          stateCbsas.push(metroArea.cbsaCode);
        });
      }
    });


    if (currentInteractive.preFilterTitlesAvailable && (titles.length > 0 || fuzzyTitles.length > 0)) {
      // 'Clean Job Titles[Clean Title]

      var logicalOperator = "Or";

      if (preFilter.titlesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = titles.map((x) => ({ operator: "Contains", value: x }));

      fuzzyTitles.forEach(x => {
        conditions.push({ operator: "Contains", value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "JJob Titles",
          column: "Job Title"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (currentInteractive.preFilterCompanyAvailable && (companies.length > 0 || fuzzyCompanies.length > 0)) {
      // 'Company Profiles'[Company Name]

      var logicalOperator = "Or";

      if (preFilter.companiesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = companies.map((x) => ({ operator: "Contains", value: x }));

      fuzzyCompanies.forEach(x => {
        conditions.push({ operator: "Contains", value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Companies",
          column: "Company"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (currentInteractive.preFilterOccupationAvailable && occupationSocCodes.length > 0) {
      // 'Occupations (SOC)'[O*NET SOC Code]

      resultFilters.push({
        $schema: '',
        filterType: 1, // Basic Filter Type
        operator: "In",
        target: {
          table: 'Occupations',
          column: 'ONET Code'
        },
        values: occupationSocCodes,
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (currentInteractive.preFilterIndustryAvailable && industryIndustryIds.length > 0) {
      // 'Industries (NAICS)'[National Industry ID]

      resultFilters.push({
        $schema: '',
        filterType: 1, // Basic Filter Type
        operator: "In",
        target: {
          table: 'Industries (NAICS)',
          column: 'NAICS ID'
        },
        values: industryIndustryIds,
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    if (currentInteractive.preFilterRegionAvailable && stateCbsas.length > 0) {
      // 'Regions'[Metro Area ID (CBSA)]

      resultFilters.push({
        $schema: '',
        filterType: 1, // Basic Filter Type
        operator: "In",
        target: {
          table: 'Regions',
          column: 'CBSA Code'
        },
        values: stateCbsas,
        displaySettings: {
          isHiddenInViewMode: true
        }
      });

    }

    return resultFilters;
  }*/
}
